module.exports = __webpack_public_path__ + "static/media/art-of-precision.c7aa207f.jpg";